// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__QA_r7","title":"ClientReferral_title__255nv","itemText":"ClientReferral_itemText__2vPiI"};